import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__ from "../button.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__checkbox_mjs_c7b53b02__ from "../checkbox.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__ from "../combobox.mjs";
import * as __WEBPACK_EXTERNAL_MODULE_cmdk__ from "cmdk";
import * as __WEBPACK_EXTERNAL_MODULE__command_mjs_d41b7025__ from "../command.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__ from "../../lib/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__ from "lucide-react";
import * as __WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_ccd04ade__ from "../../lib/SIcon.mjs";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__filter_context_mjs_5aebc15f__ from "./filter-context.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__lib_array_mjs_4b0a95e0__ from "../../lib/array.mjs";
const FilterFieldSelector = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(__FilterFieldSelector);
function __FilterFieldSelector({ filters: propFilters, fields: propFields, actions: propActions, align = "start", onAIFilterRequest }) {
    const contextData = propFilters && propFields && propActions ? null : (0, __WEBPACK_EXTERNAL_MODULE__filter_context_mjs_5aebc15f__.useFiltersContext)();
    const filters = propFilters ?? contextData?.filters ?? [];
    const fields = propFields ?? contextData?.fields ?? [];
    const actions = propActions ?? contextData?.actions ?? {};
    const [open, setOpen] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const [value, setValue] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)("");
    const inputRef = (0, __WEBPACK_EXTERNAL_MODULE_react__.useRef)(null);
    const hasFilters = filters.length > 0;
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        if (!open) setTimeout(()=>setValue(""), 150);
    }, [
        open
    ]);
    const closePopover = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        setOpen(false);
    }, []);
    const handleAIFilter = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        if (onAIFilterRequest && value) {
            closePopover();
            onAIFilterRequest(value);
        }
    }, [
        onAIFilterRequest,
        value,
        closePopover
    ]);
    const hasSearch = value && value.trim().length > 0;
    const content = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxInput, {
                    value: value,
                    onValueChange: setValue,
                    ref: inputRef,
                    placeholder: "Ask AI to generate, or search fields..."
                }),
                !onAIFilterRequest && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxEmpty, {
                    children: "No results"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxList, {
                    className: "max-h-fit",
                    children: [
                        !hasSearch && onAIFilterRequest && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxGroup, {
                            className: "-mx-1",
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(AIFilterItem, {
                                hasFields: fields.length > 0,
                                onSelect: handleAIFilter
                            })
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxGroup, {
                            children: fields.map((field)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilterableField, {
                                    field: field,
                                    actions: actions,
                                    closePopover: closePopover
                                }, field.id))
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxGroup, {
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(QuickSearchFilters, {
                                search: value,
                                filters: filters,
                                fields: fields,
                                actions: actions
                            })
                        }),
                        hasSearch && onAIFilterRequest && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxGroup, {
                            forceMount: true,
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(AIFilterItem, {
                                hasFields: fields.length > 0,
                                onSelect: handleAIFilter
                            })
                        })
                    ]
                })
            ]
        }), [
        filters,
        fields,
        actions,
        value,
        hasSearch,
        closePopover,
        onAIFilterRequest,
        handleAIFilter
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.Combobox, {
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxTrigger, {
                asChild: true,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__.Button, {
                    variant: "outline",
                    className: "text-[13px] rounded-lg",
                    size: hasFilters ? "icon_sm" : "sm",
                    children: [
                        hasFilters ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.Plus, {
                            className: "size-4"
                        }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.FilterIcon, {
                            className: "size-4"
                        }),
                        !hasFilters && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                            children: "Filter"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxContent, {
                align: align,
                side: "bottom",
                className: "w-fit p-0",
                loop: true,
                filter: (value, search, keywords)=>{
                    const extendValue = `${value} ${keywords?.join(" ")}`;
                    return extendValue.toLowerCase().includes(search.toLowerCase()) ? 1 : 0;
                },
                children: content
            })
        ]
    });
}
const AIFilterItem = ({ hasFields, onSelect })=>{
    const search = (0, __WEBPACK_EXTERNAL_MODULE_cmdk__.useCommandState)((state)=>state.search);
    const hasSearch = search && search.trim().length > 0;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__command_mjs_d41b7025__.CommandItem, {
                value: "__ai_filter__",
                disabled: !hasSearch || !hasFields,
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__.cn)("relative flex h-[30px] group/item cursor-default select-none items-center rounded-md font-normal px-2.5 text-sm outline-none text-foreground/[0.75] data-[disabled=true]:pointer-events-none data-[selected=true]:bg-grayscale-dark data-[selected=true]:text-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 transition-colors justify-between gap-2"),
                onSelect: ()=>{
                    if (hasSearch && hasFields) onSelect();
                },
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_ccd04ade__.SIcon, {
                                type: "list-sparkle",
                                className: "!size-3.5 text-secondary-foreground group-data-[selected=true]/item:text-foreground transition-colors"
                            }),
                            "AI filter"
                        ]
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__.cn)("text-muted-foreground font-normal", hasSearch ? "text-[13px]" : "text-xs"),
                        children: hasSearch ? `"${search}"` : "Start typing to generate..."
                    })
                ]
            }),
            !hasSearch && hasFields && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxSeparator, {})
        ]
    });
};
function FilterableField({ field, actions, closePopover }) {
    const itemRef = (0, __WEBPACK_EXTERNAL_MODULE_react__.useRef)(null);
    const prefetch = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(async ()=>{
        if (field.dataProvider?.getOptions) try {
            await field.dataProvider.getOptions();
        } catch (error) {
            console.warn("Failed to prefetch options for field:", field.id, error);
        }
        if (field.dataProvider?.getValues) try {
            await field.dataProvider.getValues();
        } catch (error) {
            console.warn("Failed to prefetch values for field:", field.id, error);
        }
        if (field.dataProvider?.getRange) try {
            await field.dataProvider.getRange();
        } catch (error) {
            console.warn("Failed to prefetch range for field:", field.id, error);
        }
    }, [
        field
    ]);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        const target = itemRef.current;
        if (!target) return;
        const observer = new MutationObserver((mutations)=>{
            for (const mutation of mutations)if ("attributes" === mutation.type) {
                const isSelected = "true" === target.getAttribute("data-selected");
                if (isSelected) prefetch();
            }
        });
        observer.observe(target, {
            attributes: true,
            attributeFilter: [
                "data-selected"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        prefetch
    ]);
    const handleSelect = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        actions.addFilter(field, "", []);
        closePopover();
        setTimeout(()=>{
            const filterPills = document.querySelectorAll("[data-filter-id]");
            const lastFilterPill = filterPills[filterPills.length - 1];
            const operatorButton = lastFilterPill?.querySelector("[data-filter-operator-trigger]");
            operatorButton?.click();
        }, 100);
    }, [
        field,
        actions,
        closePopover
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxItem, {
        ref: itemRef,
        value: field.id,
        keywords: [
            field.label
        ],
        onSelect: handleSelect,
        className: "group",
        onMouseEnter: prefetch,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
            className: "flex w-full items-center justify-between",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: "inline-flex items-center gap-1.5",
                children: [
                    field.icon && /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].createElement(field.icon, {
                        strokeWidth: 2.25,
                        className: "size-4"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                        children: field.label
                    })
                ]
            })
        })
    }, field.id);
}
const QuickSearchFilters = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(__QuickSearchFilters);
function __QuickSearchFilters({ search, filters: propFilters, fields: propFields, actions: propActions }) {
    const contextData = propFilters && propFields && propActions ? null : (0, __WEBPACK_EXTERNAL_MODULE__filter_context_mjs_5aebc15f__.useFiltersContext)();
    const filters = propFilters ?? contextData?.filters ?? [];
    const fields = propFields ?? contextData?.fields ?? [];
    const actions = propActions ?? contextData?.actions ?? {};
    if (!search || search.trim().length < 2) return null;
    const selectFields = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>fields.filter((f)=>(0, __WEBPACK_EXTERNAL_MODULE__lib_array_mjs_4b0a95e0__.isAnyOf)(f.type, [
                "select",
                "multiSelect"
            ])), [
        fields
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: selectFields.map((field)=>{
            const filter = filters.find((f)=>f.fieldId === field.id);
            const options = [];
            function handleOptionSelect(value, check) {
                if (check) {
                    const existingFilter = filters.find((f)=>f.fieldId === field.id);
                    if (existingFilter) {
                        const newValues = Array.from(new Set([
                            ...existingFilter.values,
                            value
                        ]));
                        actions.setFilterValue(existingFilter.id, newValues);
                    } else actions.addFilter(field, "isAnyOf", [
                        value
                    ]);
                } else {
                    const existingFilter = filters.find((f)=>f.fieldId === field.id);
                    if (existingFilter) {
                        const newValues = existingFilter.values.filter((v)=>v !== value);
                        if (0 === newValues.length) actions.removeFilter(existingFilter.id);
                        else actions.setFilterValue(existingFilter.id, newValues);
                    }
                }
            }
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react__["default"].Fragment, {
                children: options.map((option)=>{
                    const checked = Boolean(filter?.values.includes(option.value));
                    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxItem, {
                        value: option.value.toString(),
                        keywords: [
                            option.label,
                            option.value.toString()
                        ],
                        onSelect: ()=>{
                            handleOptionSelect(option.value.toString(), !checked);
                        },
                        className: "group",
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                            className: "flex items-center gap-1.5 group",
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__checkbox_mjs_c7b53b02__.Checkbox, {
                                    checked: checked,
                                    className: "opacity-0 data-[state=checked]:opacity-100 group-data-[selected=true]:opacity-100 dark:border-ring mr-1"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    className: "flex items-center w-4 justify-center",
                                    children: option.icon && /*#__PURE__*/ ((0, __WEBPACK_EXTERNAL_MODULE_react__.isValidElement)(option.icon) ? option.icon : "function" == typeof option.icon && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(option.icon, {
                                        className: "size-4 text-primary"
                                    }))
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                    className: "flex items-center gap-0.5",
                                    children: [
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                            className: "text-muted-foreground",
                                            children: field.label
                                        }),
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.ChevronRightIcon, {
                                            className: "size-3.5 text-muted-foreground/75"
                                        }),
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                            children: option.label
                                        })
                                    ]
                                })
                            ]
                        })
                    }, option.value);
                })
            }, field.id);
        })
    });
}
export { FilterFieldSelector, FilterableField, QuickSearchFilters };
